import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {Link} from 'shells/link/link';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {ModalBody} from 'shells/typography/modal-body';
import {ModalHeader} from 'shells/typography/modal-header';

import styles from './utm-help.module.css';

export function UtmHelp() {
    return (
        <div className={styles.container}>
            <ModalHeader>What are UTM parameters?</ModalHeader>
            <SpacerGroup mb={32}>
                <SpacerGroup mb={16}>
                    <ModalBody>
                        Software like{' '}
                        <Link
                            href='https://support.google.com/analytics/answer/1033863?hl=en'
                            newTab={true}
                        >
                            Google Analytics allows you to create UTM parameters
                        </Link>
                        , which help you understand what a recipient did after clicking one of your
                        links.
                    </ModalBody>
                </SpacerGroup>
                <ModalBody>
                    Nutshell enables you to add these parameters so that you can gather tracking
                    data from your Nutshell outreach.
                </ModalBody>
            </SpacerGroup>
            <BulletedList
                bullets={[
                    <ModalBody key='1'>
                        <b>Source</b> helps you identify the source of your traffic, like a website
                        or publication
                    </ModalBody>,
                    <ModalBody key='2'>
                        <b>Medium</b> identifies the medium the link was used on, like an email or
                        CPC
                    </ModalBody>,
                    <ModalBody key='3'>
                        <b>Campaign</b> identifies a specific campaign, like a product launch or
                        specific promotion
                    </ModalBody>,
                ]}
            />
            <ModalBody>
                <i>
                    You can find this tracking data in your Google Analytics account. It is not
                    housed inside of Nutshell.
                </i>
            </ModalBody>
        </div>
    );
}
